export default __webpack_public_path__ + "static/media/searchIcon.ba811613.svg";